import React, { useCallback, useEffect, useState } from 'react';
import { FaSearch } from 'react-icons/fa';
import Table from '../../../components/Table/Table';
import Input from '../../../components/Input/Input';
import Button from '../../../components/Button/Button';
import Loader from '../../../components/Loader/Loader';
import SurveyStatusPill from './SurveyStatusPill';
import { getSurveyCompletion } from '../../../services/SurveyService';

const initials = (name) => name.split(' ').map((part) => part[0]).slice(0, 2).join('').toUpperCase();

const FILTERS = [
  { key: 'all', label: 'All' },
  { key: 'completed', label: 'Completed' },
  { key: 'pending', label: 'Pending' },
];

const SurveyCompletionTab = ({ survey, onExportCsv, onViewAnswers }) => {
  const [filter, setFilter] = useState('all');
  const [search, setSearch] = useState('');
  const [students, setStudents] = useState([]);
  const [isLoader, setIsLoader] = useState(true);

  const fetchStudents = useCallback(async (statusFilter, searchTerm) => {
    try {
      setIsLoader(true);
      const response = await getSurveyCompletion(survey.id, {
        ...(statusFilter !== 'all' ? { status: statusFilter } : {}),
        search: searchTerm,
      });
      if (response.status === 200) {
        setStudents(response.data.data);
      }
    } catch (error) {
      console.error('API Error:', error.response);
    } finally {
      setIsLoader(false);
    }
  }, [survey.id]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      fetchStudents(filter, search);
    }, 300);
    return () => clearTimeout(timeout);
  }, [filter, search, fetchStudents]);

  const cols = [
    {
      title: 'Student',
      key: 'name',
      sortValue: (row) => row.name,
      render: (row) => (
        <div className="survey-table-student">
          <span className="survey-avatar">{initials(row.name)}</span>
          <span>{row.name}</span>
        </div>
      ),
    },
    { title: 'Roll', key: 'roll_no', sortValue: (row) => row.roll_no, render: (row) => row.roll_no },
    { title: 'ID Number', key: 'id_number', render: (row) => row.id_number },
    { title: 'Class', key: 'program_name', render: (row) => row.program_name },
    {
      title: 'Status',
      key: 'completed',
      render: (row) => <SurveyStatusPill status={row.completed ? 'completed' : 'pending'} />,
    },
    { title: 'Submitted', render: (row) => row.submitted_at || '–' },
    {
      title: '',
      render: (row) => (
        row.completed && (
          <button type="button" className="survey-inline-link" onClick={() => onViewAnswers(row.student_id)}>
            View answers &rarr;
          </button>
        )
      ),
    },
  ];

  return (
    <div className="card survey-panel">
      <div className="survey-panel-body">
        <div className="survey-completion-toolbar">
          <div className="survey-segmented">
            {FILTERS.map((f) => (
              <button
                key={f.key}
                type="button"
                className={`survey-segmented-btn ${filter === f.key ? 'active' : ''}`}
                onClick={() => setFilter(f.key)}
              >
                {f.label}
              </button>
            ))}
          </div>

          <div className="survey-search-box survey-completion-search">
            <FaSearch className="survey-search-icon" />
            <Input
              type="text"
              name="completion-search"
              placeholder="Search name / Admission Number..."
              value={search}
              onChangeHandler={(e) => setSearch(e.target.value)}
            />
          </div>

          <Button variant="light" className="survey-completion-export" onClick={onExportCsv}>
            &darr; Export CSV
          </Button>
        </div>

        {isLoader ? <Loader /> : <Table cols={cols} data={students} />}
      </div>
    </div>
  );
};

export default SurveyCompletionTab;
